import { Box, Divider, Grid } from '@mui/material'
import CustomText from 'components/common/CustomText/CustomText'
import CustomFormTextInput from 'components/inputs/CustomFormTextInput/CustomFormTextInput'
import { FieldError, FieldErrorsImpl, Merge, useFormContext } from 'react-hook-form'
import useStyles from './styles'
import { colors } from 'styles/colors'
import { procedureDataType } from 'types/types'
import useGlobalStyles from 'styles/globalStyles'

type RHFMaybeFieldError =
  | FieldError
  | Merge<FieldError, FieldErrorsImpl<any>>
  | undefined

const toFieldError = (err: RHFMaybeFieldError): FieldError | undefined => {
  const e = err as unknown as { type?: unknown } | undefined
  if (!e || typeof e !== 'object') return undefined
  return 'type' in e ? (err as FieldError) : undefined
}

export default function Diagnosis() {
  const globalStyles = useGlobalStyles();

  const {
    register,
    formState: { errors },
  } = useFormContext<procedureDataType>()

  return (
    <Box
      className={globalStyles.sectionContainer}
    >
      <Box className={globalStyles.sectionHeader}>
        <CustomText
          text="Diagnosis"
          color={colors.primary}
          fontWeight={600}
        />
      </Box>

      <Divider />

      <Grid container p={3} spacing={2}>

        {/* Diagnosis */}
        <Grid size={{ xs: 12 }}>
          <CustomFormTextInput
            name="procedure_diagnosis"
            label="Diagnosis"
            required={false}
            placeholder="Diagnosis"
            register={register}
            error={toFieldError(errors.mrn as RHFMaybeFieldError)}
          />
        </Grid>

      </Grid>

    </Box>
  )
}
